var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2409 17.0285L14.4662 4.85999C13.6453 4.29763 12.8182 4 12.1308 4C10.8017 4 9.97949 5.06669 9.97949 6.8522V33.1519C9.97949 34.9354 10.8006 36 12.1266 36C12.8151 36 13.629 35.7021 14.4517 35.1382L32.2347 22.9699C33.3783 22.1861 34.0117 21.1313 34.0117 19.9986C34.0119 18.8666 33.3859 17.8121 32.2409 17.0285Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5d601c0fdc670653c772da7428cbccb9.svg";
export { ForwardRef as ReactComponent };